export default class DisputeLocationDetails {
  constructor({ id, name, regionId, state, country, timeZone }) {
    /** @type {number} */
    this.id = id
    /** @type {string} */
    this.name = name
    /** @type {number} */
    this.regionId = regionId
    /** @type {string} */
    this.state = state
    /** @type {string} */
    this.country = country
    /** @type {string} */
    this.timeZone = timeZone
  }
}
